/* src/app/job-signoff-land-services/partials/job-signoff-manager-land/job-signoff-manager-land.component.scss */
.blueHover:hover {
  background: #3b6ea5;
  color: white;
}
.purpleHover:hover {
  background: #7c5fa6;
  color: white;
}
.greenHover:hover {
  background: #4c9a6a;
  color: white;
}
.redHover:hover {
  background: #c0504d;
  color: white;
}
/*# sourceMappingURL=job-signoff-manager-land.component.css.map */
